import React, { useEffect, useId, useRef } from "react";
import { StreetViewIcon } from "../StreetViewIcon";
import "./StreetViewHelp.css";

const STORAGE_KEY = "multiplacer.streetview.help.v1";
export function shouldShowStreetViewHelp(): boolean {
  try { return localStorage.getItem(STORAGE_KEY) !== "seen"; }
  catch { return true; }
}
export function rememberStreetViewHelp(): void {
  try { localStorage.setItem(STORAGE_KEY, "seen"); }
  catch { /* Help remains usable when browser storage is unavailable. */ }
}

export function StreetViewHelp({ open, onOpen, onClose,
  tip = "Tips: Dra den gule figuren på plantegningen for å flytte deg til et annet sted."
}: {
  open: boolean; onOpen: () => void; onClose: () => void; tip?: string;
}) {
  const titleId = useId();
  const buttonRef = useRef<HTMLButtonElement>(null);
  const closeRef = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    if (!open) return;
    const previous = document.activeElement as HTMLElement | null;
    closeRef.current?.focus();
    return () => {
      if (previous?.isConnected && previous !== document.body) previous.focus();
      else buttonRef.current?.focus();
    };
  }, [open]);

  return <>
    <button ref={buttonRef} type="button" className="streetview-help-trigger" onClick={onOpen}
      aria-haspopup="dialog" aria-expanded={open}>
      <span aria-hidden="true">?</span> Navigasjonshjelp
    </button>
    {open && <div className="streetview-help-backdrop">
      <section role="dialog" aria-modal="true" aria-labelledby={titleId} className="streetview-help-card"
        onKeyDown={event => {
          event.stopPropagation();
          if (event.key === "Escape") { event.preventDefault(); onClose(); }
          // The acknowledgement is the dialog's only interactive control.
          if (event.key === "Tab") { event.preventDefault(); closeRef.current?.focus(); }
        }} onKeyUp={event => event.stopPropagation()}>
        <div className="streetview-help-heading"><span className="streetview-help-person"><StreetViewIcon size={32} /></span>
          <div><div className="streetview-help-eyebrow">STREETVIEW</div><h2 id={titleId}>Se deg rundt i bygget</h2></div>
        </div>
        <p>Bruk musen til å se deg rundt og tastaturet til å gå.</p>
        <dl className="streetview-help-controls">
          <div><dt>Mus + dra</dt><dd>Hold venstre museknapp inne og se deg rundt</dd></div>
          <div><dt><kbd>W</kbd> <kbd>S</kbd></dt><dd>Gå fremover / bakover</dd></div>
          <div><dt><kbd>A</kbd> <kbd>D</kbd></dt><dd>Gå til venstre / høyre</dd></div>
          <div><dt><kbd>Q</kbd> <kbd>E</kbd></dt><dd>Flytt opp / ned</dd></div>
          <div><dt><kbd>Shift</kbd></dt><dd>Hold inne for å gå raskere</dd></div>
        </dl>
        <div className="streetview-help-tip">{tip}</div>
        <button ref={closeRef} className="streetview-help-start" type="button" onClick={onClose}>Skjønner, la oss gå</button>
        <small>Du finner alltid denne guiden under «Navigasjonshjelp».</small>
      </section>
    </div>}
  </>;
}
